import type { ChildrenProp } from "@charterindex/armoury-www";
import type { JSX } from "react";
import type { App } from "../app";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import { Button, css, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, styled, useMediaQuery, useTheme } from "@mui/material";
import { useObservable } from "ecce-react";


const RootDialogRoot = styled(Dialog)(({ theme }) => css`
	.MuiDialog-paper, .MuiDialogContent-root {
		// Required to allow popover components (eg <Autocomplete>) to display out
		// of the bound of the dialog when disablePortal is set.
		overflow-y: visible;
	}
	.MuiDialogTitle-root {
		display: flex;
		justify-content: space-between;
		align-items: center;
		
		.closeButton {
			margin-right: ${theme.spacing(-1)};
		}
	}

	.MuiDialogContent-root {
		display: grid;
	}

	form {
		max-height: 50%;
	}


	${theme.breakpoints.up("sm")} {
		.MuiDialog-paper {
			width: 400px;
			height: 375px;
			border-radius: ${theme.shape.borderRadius}px;
		}
		
		form {
			max-height: unset;
		}
	}
`);

const FORM_ID = "purser__mainForm";
export const RootDialog = (p: { app: App } & ChildrenProp): JSX.Element => {
	const large = useMediaQuery(useTheme().breakpoints.up("sm"));
	useObservable(p.app, "data");
	useObservable(p.app, "activeStep");
	useObservable(p.app, "submitting");

	return (
		<RootDialogRoot
			fullScreen={ !large }
			open={ !!p.app.data }
			onClose={ p.app.closeDialog }
			disablePortal
		>
			<DialogTitle>
				<span>
					Sign Up to Charter Index
				</span>
				<IconButton className="closeButton" onClick={ p.app.closeDialog }>
					<CloseIcon/>
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Stack
					component="form"
					id={ FORM_ID }
					onSubmit={ p.app.handleFormSubmitted }
					gap={ 2 }
				>
					{ p.app.activeStep?.view() }
				</Stack>
			</DialogContent>
			<DialogActions>
				{ p.app.previousStep && (
					<Button
						onClick={ p.app.goBack }
						startIcon={ <ArrowBackIcon/> }
						color="inherit"
						sx={{ marginRight: "auto" }}
					>
						{ p.app.previousStep.title }
					</Button>
				) }
				{ p.app.canSubmit && (
					<Button
						type="submit"
						endIcon={ <ArrowForwardIcon/> }
						form={ FORM_ID }
						disabled={ p.app.submitting }
					>
						Next
					</Button>
				) }
				{ !p.app.canSubmit && (
					<Button onClick={ p.app.closeDialog }>
						OK
					</Button>
				) }
			</DialogActions>
		</RootDialogRoot>
	);
};
